import React from 'react';

const SERVICES = [
  {
    id: 1,
    icon: '💻',
    title: 'Développement Web',
    description: 'Applications web modernes et performantes avec React, Node.js et technologies cloud.'
  },
  {
    id: 2,
    icon: '📱',
    title: 'Applications Mobiles',
    description: 'Solutions mobiles natives et cross-platform pour iOS et Android.'
  },
  {
    id: 3,
    icon: '☁️',
    title: 'Architecture Cloud',
    description: 'Migration et optimisation d\'infrastructures sur AWS, VPS etc...'
  },
  {
    id: 4,
    icon: '🔒',
    title: 'Cybersécurité',
    description: 'Audit de sécurité, pentesting et protection contre les menaces.'
  },
  {
    id: 5,
    icon: '🤖',
    title: 'Intelligence Artificielle',
    description: 'Solutions IA et machine learning pour automatiser vos processus.'
  },
  {
    id: 6,
    icon: '🚀',
    title: 'DevOps',
    description: 'Pipelines d\'intégration continue et déploiement automatisé.'
  }
];

export default function Services() {
  return (
      <section className="services" id="services">
        <div className="container">
          <div className="section-header">
            <h2>Nos Services</h2>
            <p>Une gamme complète de solutions technologiques adaptées à vos besoins</p>
          </div>

          <div className="services-grid">
            {SERVICES.map(service => (
                <div key={service.id} className="service-card">
                  <div className="service-icon">{service.icon}</div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
            ))}
          </div>
        </div>
      </section>
  );
}